export const clientObjectives = [
  'Stress Management',
  'Time Management',
  'Relationship Quality',
  'Work-Life Balance',
  'Personal Development',
  'Health and Wellness',
];

export const pronounOptions = [
  { value: 'She', label: 'She' },
  { value: 'He', label: 'He' },
  { value: 'Other', label: 'Other' },
  { value: 'Prefer not to say', label: 'Prefer not to say' },
];

export enum ClientType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
  GROUP = 'GROUP',
}
